import styled from "@emotion/styled";
import { SkeletonBlock } from "components/general/Skeleton";
import { useIsMobile } from "hooks/useDeviceType";
import { useIsTradeHistoryReturned } from "hooks/useIsTradeHistoryReturned";
import { useCallback } from "react";
import { TransactionDetail } from "../../../types/history";
import { CHAINS } from "config/chains";

export const NetworkCell = ({ chainId }: { chainId: TransactionDetail["chain_id"] }) => {
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 16 : 20;
  const isTradeHistoryReturned = useIsTradeHistoryReturned();

  const iconByNetwork = useCallback(
    (networkId: number) => {
      const config = CHAINS[networkId];
      if (config?.icon) {
        return <config.icon color={config?.iconColor} width={iconSize} height={iconSize} />;
      }
      return null;
    },
    [iconSize]
  );

  return (
    <Container iconSize={iconSize}>
      {isTradeHistoryReturned ? iconByNetwork(chainId) : <SkeletonBlock />}
    </Container>
  );
};

// Sub-components

interface ContainerProps {
  iconSize: number;
}

export const Container = styled.div<ContainerProps>(({ iconSize }) => ({
  width: `${iconSize}px`,
  height: `${iconSize}px`,
  lineHeight: 1,
}));
